"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.CHECKBOX_LIST = exports.RADIO_LIST = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _underscore = _interopRequireDefault(require("underscore"));

var _CheckBox = _interopRequireWildcard(require("../CheckBox/CheckBox"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var RADIO_LIST = 'radio';
exports.RADIO_LIST = RADIO_LIST;
var CHECKBOX_LIST = 'checkbox';
exports.CHECKBOX_LIST = CHECKBOX_LIST;
var primitiveValueTypes = [_propTypes.default.bool, _propTypes.default.string, _propTypes.default.number];

var RadioGroup = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(RadioGroup, _Component);

  var _super = _createSuper(RadioGroup);

  function RadioGroup(props) {
    var _this;

    (0, _classCallCheck2.default)(this, RadioGroup);
    _this = _super.call(this, props);
    _this.renderBtn = _this.renderBtn.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleChange = _this.handleChange.bind((0, _assertThisInitialized2.default)(_this));
    _this.state = _this.setSelectedItem(props.value);
    return _this;
  }

  (0, _createClass2.default)(RadioGroup, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.value && nextProps.value !== this.props.value) {
        this.setState(this.setSelectedItem(nextProps.value));
      }
    }
  }, {
    key: "setSelectedItem",
    value: function setSelectedItem(selectedItem) {
      if (!_underscore.default.isArray(selectedItem) && this.props.listType === CHECKBOX_LIST) {
        selectedItem = typeof selectedItem === 'undefined' ? [] : [selectedItem];
      } else if (_underscore.default.isArray(selectedItem) && this.props.listType === RADIO_LIST) {
        console.warn('Array should be supplied for initial value of RADIO_LIST!');
        selectedItem = selectedItem.length >= 1 ? selectedItem[0] : undefined;
      }

      return {
        selectedItem: selectedItem,
        indeterminates: {}
      };
    }
  }, {
    key: "handleChange",
    value: function handleChange(value, opt) {
      var _this2 = this;

      return function (selectedValue) {
        if (_this2.props.listType === CHECKBOX_LIST) {
          var selectedItems = _this2.state.selectedItem || [];
          var indeterminates = _this2.state.indeterminates || {};

          if (opt && opt.indeterminate) {
            indeterminates[value] = false;
          }

          if (selectedValue === null) {
            selectedItems = _underscore.default.without(selectedItems, value);
          } else {
            selectedItems.push(value);
          }

          _this2.setState({
            selectedItem: selectedItems,
            indeterminates: indeterminates
          }, function () {
            return _this2.props.onChange(selectedItems, _this2.props.name, value);
          });
        } else {
          if (_this2.state.selectedItem !== value) {
            _this2.setState({
              selectedItem: value
            }, function () {
              return _this2.props.onChange(value, _this2.props.name);
            });
          }
        }
      };
    }
  }, {
    key: "renderBtn",
    value: function renderBtn(opt) {
      var value = opt.value,
          label = opt.label,
          _opt$className = opt.className,
          className = _opt$className === void 0 ? '' : _opt$className,
          _opt$indeterminate = opt.indeterminate,
          indeterminate = _opt$indeterminate === void 0 ? false : _opt$indeterminate;
      var indeterminates = this.state.indeterminates;
      var checked = this.props.listType === CHECKBOX_LIST && _underscore.default.contains(this.state.selectedItem, value) || this.props.listType === RADIO_LIST && this.state.selectedItem === value;
      return /*#__PURE__*/_react.default.createElement(_CheckBox.default, {
        className: className,
        name: this.props.name,
        label: label,
        value: value,
        type: this.props.listType,
        key: "".concat(this.props.name, "-").concat(value),
        checked: checked,
        indeterminate: indeterminates[value] === false ? false : indeterminate,
        style: this.props.style,
        onChange: this.handleChange(value, opt)
      });
    }
  }, {
    key: "render",
    value: function render() {
      var options = this.props.options;

      if (!_underscore.default.isArray(options)) {
        options = _underscore.default.map(options, function (label, value) {
          return {
            label: label,
            value: value
          };
        });
      }

      return /*#__PURE__*/_react.default.createElement("div", {
        className: "form-group radio-group",
        key: this.props.name
      }, _underscore.default.map(options, this.renderBtn));
    }
  }], [{
    key: "propTypes",
    get: function get() {
      return {
        options: _propTypes.default.oneOfType([_propTypes.default.objectOf(_propTypes.default.oneOfType(primitiveValueTypes)), _propTypes.default.arrayOf(_propTypes.default.shape({
          label: _propTypes.default.node,
          value: _propTypes.default.oneOfType(primitiveValueTypes),
          className: _propTypes.default.string
        }))]).isRequired,
        name: _propTypes.default.string.isRequired,
        value: _propTypes.default.oneOfType([].concat(primitiveValueTypes, [_propTypes.default.arrayOf(primitiveValueTypes)])),
        onChange: _propTypes.default.func,
        listType: _propTypes.default.oneOf([RADIO_LIST, CHECKBOX_LIST]),
        style: _CheckBox.default.propTypes.style
      };
    }
  }, {
    key: "defaultProps",
    get: function get() {
      return {
        listType: RADIO_LIST,
        style: _CheckBox.STYLE_DEFAULT
      };
    }
  }]);
  return RadioGroup;
}(_react.Component);

exports.default = RadioGroup;